import { House, MessagesSquare, CircleUser } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import API from "../../../utils/Api";

const Header = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const [openMenu, setOpenMenu] = useState(false);
  const isActive = (path) => location.pathname === path;
  const apiBase = API.defaults.baseURL?.replace(/\/api\/?$/, "") || "";
  const resolveAvatar = (url) =>
    url ? (url.startsWith("http") ? url : `${apiBase}${url}`) : "";

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-gray-100">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-4 sm:px-6 lg:px-8 h-14">
        {/* Logo */}
        <Link
          to="/"
          className="text-lg font-semibold text-gray-900"
        >
          সংযোগ
        </Link>

        {/* Right-side navigation */}
        <nav className="flex items-center gap-6">
          {/* Home */}
          <Link
            to="/"
            className={`flex items-center gap-2 text-sm transition-colors ${
              isActive("/") 
                ? "text-indigo-600" 
                : "text-gray-500 hover:text-gray-900"
            }`}
          >
            <House size={18} strokeWidth={1.6} />
            <span className="font-medium">Home</span>
          </Link>

          {/* Messenger */}
          <Link
            to="/chat"
            className={`flex items-center gap-2 text-sm transition-colors ${
              isActive("/chat") 
                ? "text-indigo-600" 
                : "text-gray-500 hover:text-gray-900"
            }`}
          >
            <MessagesSquare size={18} strokeWidth={1.6} />
            <span className="font-medium">Messenger</span>
          </Link>
 

          {/* User name with avatar dropdown */}
          <div className="relative">
            <button
              onClick={() => setOpenMenu((prev) => !prev)}
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
            >
              <img
                src={resolveAvatar(user?.avatarUrl) || ""}
                alt={user?.name || user?.username || "User"}
                className="w-7 h-7 rounded-full object-cover border"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <span className="font-medium">
                {user?.name || user?.username || "Account"}
              </span>
            </button>

            {openMenu && (
              <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-sm z-30">
                <Link
                  to="/profile"
                  onClick={() => setOpenMenu(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                >
                  View Profile
                </Link>
                <Link
                  to="/login"
                  onClick={() => {
                    localStorage.removeItem("userToken");
                    setOpenMenu(false);
                  }}
                  className="block px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                >
                  Logout
                </Link>
              </div>
            )}
          </div>

        </nav>
      </div>

    </header>
  );
};

export default Header;
